<template>
  <v-window
    v-model="win"
    touchless
  >
    <h-item value="welcome" light>
      <h-welcome @goto="win = $event" />
    </h-item>
    <h-item value="demo">
      <h-demo @back="back" />
    </h-item>
    <h-item value="form">
      <h-form @back="back" />
    </h-item>
    <!-- This last empty window-item prevents the window animation to be reversed -->
    <v-window-item>-</v-window-item>
  </v-window>
</template>

<script>
  import layout from '@/Layouts/Auth'
  import HItem from '@/Sections/Login/WindowItem'
  import HWelcome from '@/Sections/Login/Welcome'
  import HDemo from '@/Sections/Login/Demo'
  import HForm from '@/Sections/Login/Form'

  export default {
    layout,

    components: {
      HItem,
      HWelcome,
      HDemo,
      HForm,
    },

    data: () => ({
      win: undefined,
    }),

    computed: {
      showForm () {
        return this.$page.props.brand === 'HANDY' || !! localStorage.getItem('tenant')
      },
    },

    created () {
      this.win = this.showForm ? 'form' : 'welcome'
    },

    methods: {
      back () {
        this.win = 'welcome'
      },
    },
  }
</script>
